import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Modal } from 'react-bootstrap-5';

import TaskForm from 'components/tasks/task_form';
import {
  addTask,
  removeTask,
  updateTask,
  hideTaskModal
} from 'bundles/project/actions/index';

export class TaskModal extends React.Component {
  static propTypes = {
    addTask: PropTypes.func.isRequired,
    assigneeOptions: PropTypes.array,
    availableDatabaseOptions: PropTypes.arrayOf(PropTypes.array),
    defaultTaskAssignee: PropTypes.object.isRequired,
    defaultTaskAssociation: PropTypes.shape({
      associatedModelId: PropTypes.number.isRequired,
      associatedModelType: PropTypes.string.isRequired,
      default: PropTypes.bool.isRequired,
      name: PropTypes.string.isRequired
    }),
    defaultTaskAssociations: PropTypes.array.isRequired,
    errors: PropTypes.arrayOf(PropTypes.string),
    features: PropTypes.shape({
      crm: PropTypes.bool
    }).isRequired,
    hideContactSelect: PropTypes.bool,
    hidePropertySelect: PropTypes.bool,
    hideTaskModal: PropTypes.func.isRequired,
    isLogged: PropTypes.bool,
    isNote: PropTypes.bool,
    projectId: PropTypes.number.isRequired,
    removeTask: PropTypes.func.isRequired,
    show: PropTypes.bool,
    taskToEdit: PropTypes.object,
    updateTask: PropTypes.func.isRequired
  }

  handleSave = (task) => {
    if (this.props.taskToEdit) {
      this.props.updateTask(task);
    } else {
      this.props.addTask(task);
    }
  }

  title() {
    const { isNote, isLogged, taskToEdit } = this.props;

    if (isNote) {
      return taskToEdit ? 'Edit Note' : 'Create a Note';
    }

    if (taskToEdit) return 'Edit Activity';
    if (isLogged) return 'Log an Activity';
    return 'Create a Task';
  }

  render() {
    const { defaultTaskAssociation } = this.props;
    const selectedContactName = defaultTaskAssociation ? defaultTaskAssociation.name : null;

    return (
      <Modal
        backdrop="static"
        className="contact-modal fill-required overflow-visible"
        name="task-form-modal"
        show={this.props.show}
        size="lg"
        onHide={this.props.hideTaskModal}
      >
        <Modal.Header closeButton>
          <Modal.Title>{this.title()}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <TaskForm
            assigneeOptions={this.props.assigneeOptions}
            availableDatabaseOptions={this.props.availableDatabaseOptions}
            defaultAssociatedModels={this.props.defaultTaskAssociations}
            defaultTaskAssignee={this.props.defaultTaskAssignee}
            errors={this.props.errors}
            existingTask={this.props.taskToEdit}
            hideAssociations={!this.props.features.crm}
            hideContactSelect={this.props.hideContactSelect}
            hidePropertySelect={this.props.hidePropertySelect}
            isNote={this.props.isNote}
            logTask={this.props.isLogged}
            projectId={this.props.projectId}
            providedTitle={selectedContactName ? `Call with ${selectedContactName}` : null}
            selectedContactName={selectedContactName}
            onCancel={this.props.hideTaskModal}
            onDelete={this.props.removeTask}
            onSave={this.handleSave}
          />
        </Modal.Body>
      </Modal>
    );
  }
}

const mapStateToProps = (
  { availableDatabaseOptions, project, taskModal, taskOptions, features }, { defaultTaskAssignee }
) => {
  const defaultTaskAssociations = [project.defaultTaskAssociation];
  if (taskModal.defaultTaskAssociation) {
    defaultTaskAssociations.push(taskModal.defaultTaskAssociation);
  }

  const assigneeOptions = [...project.collaborators, ...project.otherAuthorizedUsers];
  if (assigneeOptions.every(user => user.id !== defaultTaskAssignee.id)) assigneeOptions.unshift(defaultTaskAssignee);

  return {
    assigneeOptions,
    availableDatabaseOptions,
    defaultTaskAssociations,
    features,
    hideContactSelect: taskOptions.hideContactSelect,
    hidePropertySelect: taskOptions.hidePropertySelect,
    projectId: project.id,
    ...taskModal
  };
};

const mapDispatchToProps = { addTask, removeTask, updateTask, hideTaskModal };

export default connect(mapStateToProps, mapDispatchToProps)(TaskModal);
